import { render } from "./AddBaseStationPage.vue?vue&type=template&id=48d8a71b"
import script from "./AddBaseStationPage.vue?vue&type=script&lang=js"
export * from "./AddBaseStationPage.vue?vue&type=script&lang=js"

import "./AddBaseStationPage.vue?vue&type=style&index=0&id=48d8a71b&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__